import shadow from 'images/bots/bot-shadow.svg';
import { cn } from 'lib/utils';
import Img from 'next/image';
import PropTypes from 'prop-types';

const BotImage = ({ className = '', src }) => {
  return (
    <div className="flex flex-col items-center">
      <Img
        alt="Resistbot illustrated character"
        height="160"
        width="160"
        className={cn(className, 'animate-floating', 'h-40')}
        src={src}
      />
      <Img
        src={shadow}
        height="15"
        width="100"
        className={cn(className, 'animate-shadow', 'dark:animate-darkShadow')}
        alt="Shadow for Resistbot illustrated character"
      />
    </div>
  );
};

BotImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
};

export default BotImage;
